export const environment = {
  production: false,
  hmr: false,
  showSystemStats: false,
  apiUrl: 'https://cam-e1.cmcati.vn/api/v1',
  keyMaps: 'cb1_29pf_1_e45762ccd9d2e4391dcd3ce0',
  wsUrl: 'wss://cam-e1.cmcati.vn/ws',
  urlIAM: 'https://iam.cmcati.vn/',
  realm: 'camai',
  clientId: 'client-side',
  // domain: 'https://cam-e1.cmcati.vn',

  modules: {
    smartcity: true
  },

  bboxSyncOffsetMs: 0,
  opsDataUrl: '/ops-data',
  mediaRewrite: [
    { from: 'https://cam-media-dev.cmcati.vn/live-mtx1', to: '/live-mtx1' },
    { from: 'https://cam-media-dev.cmcati.vn/live-mtx2', to: '/live-mtx2' },
    { from: 'https://cam-media-dev.cmcati.vn/whep-mtx1', to: '/whep-mtx1' },
    { from: 'https://cam-media-dev.cmcati.vn/whep-mtx2', to: '/whep-mtx2' },
    { from: 'https://cam-media-dev.cmcati.vn/minio', to: '/minio' }
  ]
};
